import React from "react";
import TextField from "@material-ui/core/TextField";
import config from "lib/fr-config";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";

const colorCss = config.css.color;

const ErrorTypography = withStyles({
  colorSecondary: { color: colorCss.colorOfDanger, fontSize: 14 }
})(Typography);
const HelperTypography = withStyles({
  colorSecondary: { color: colorCss.colorOfPrimary, fontSize: 14 }
})(Typography);

CommonTextField.propTypes = {
  type: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  inputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  onKeyDown: PropTypes.func,
  placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  helperText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  errorText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),

  margin: PropTypes.oneOf(["none", "dense", "normal"]),
  autoFocus: PropTypes.bool,
  InputProps: PropTypes.object,

  multiline: PropTypes.bool,
  shrinkLabel: PropTypes.bool
};

CommonTextField.defaultProps = {
  type: null,
  label: null,
  inputRef: null,
  onKeyDown: null,
  placeholder: undefined,
  helperText: "",
  errorText: "",
  margin: "none",
  autoFocus: false,
  InputProps: null,
  multiline: false,
  shrinkLabel: false
};

function CommonTextField(props) {
  const {
    type,
    value,
    onChange,
    label,
    inputRef,
    onKeyDown,
    placeholder,
    helperText,
    errorText,
    margin,
    autoFocus,
    InputProps,
    multiline,
    shrinkLabel
  } = props;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end"
      }}
    >
      <TextField
        autoFocus={autoFocus}
        inputRef={inputRef}
        onKeyDown={onKeyDown}
        fullWidth
        label={label}
        InputLabelProps={shrinkLabel ? { shrink: true } : undefined}
        type={type}
        margin={margin}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        InputProps={InputProps}
        multiline={multiline}
      />
      {errorText && errorText !== "" && (
        <ErrorTypography color="secondary">{errorText}</ErrorTypography>
      )}
      {helperText && helperText !== "" && (
        <HelperTypography color="secondary">{helperText}</HelperTypography>
      )}
    </div>
  );
}

export default CommonTextField;
